// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* تنظیمات کلی */
body {
    margin: 0;
    font-family: Arial, sans-serif;
    background-color: #f8f9fa;
}

/* استایل هدر */
.header {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    padding: 15px 20px;
    border-bottom: 2px solid #ddd;
}

.company-logo {
    max-height: 60px;
    margin-right: 15px;
}

.company-name {
    font-size: 24px;
    font-weight: bold;
    color: #333;
}

.company-tagline {
    font-size: 14px;
    color: #777;
}

/* استایل دکمه‌ها */
.button-container {
    text-align: center;
    margin: 20px 0;
}

.btn {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    margin: 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.3s;
}

.btn:hover {
    background-color: #0056b3;
}

/* استایل جدول */
.table-container {
    width: 100%;
    overflow-x: auto; /* فعال کردن اسکرول افقی */
    margin-top: 20px;
    background: white;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.tags-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 600px; /* حداقل عرض برای جلوگیری از فشردگی بیش از حد */
}

.tags-table th,
.tags-table td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: center;
}

.tags-table th {
    background: #007bff;
    color: white;
}

.tags-table tbody tr:nth-child(even) {
    background: #f2f2f2;
}

/* واکنش‌گرایی برای موبایل */
@media screen and (max-width: 768px) {
    .table-container {
        overflow-x: auto; /* فعال کردن اسکرول افقی */
        display: block;
        white-space: nowrap; /* جلوگیری از شکستگی متن */
    }

    .tags-table {
        font-size: 14px;
        min-width: 500px;
    }

    .tags-table th,
    .tags-table td {
        padding: 8px;
    }

    .button-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .btn {
        width: 90%;
        margin: 5px 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HomePage.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,SAAS;IACT,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,WAAW;IACX,gBAAgB,EAAE,0BAA0B;IAC5C,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB,EAAE,+CAA+C;AACrE;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI;QACI,gBAAgB,EAAE,0BAA0B;QAC5C,cAAc;QACd,mBAAmB,EAAE,0BAA0B;IACnD;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ","sourcesContent":["/* تنظیمات کلی */\nbody {\n    margin: 0;\n    font-family: Arial, sans-serif;\n    background-color: #f8f9fa;\n}\n\n/* استایل هدر */\n.header {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #ffffff;\n    padding: 15px 20px;\n    border-bottom: 2px solid #ddd;\n}\n\n.company-logo {\n    max-height: 60px;\n    margin-right: 15px;\n}\n\n.company-name {\n    font-size: 24px;\n    font-weight: bold;\n    color: #333;\n}\n\n.company-tagline {\n    font-size: 14px;\n    color: #777;\n}\n\n/* استایل دکمه‌ها */\n.button-container {\n    text-align: center;\n    margin: 20px 0;\n}\n\n.btn {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    margin: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background 0.3s;\n}\n\n.btn:hover {\n    background-color: #0056b3;\n}\n\n/* استایل جدول */\n.table-container {\n    width: 100%;\n    overflow-x: auto; /* فعال کردن اسکرول افقی */\n    margin-top: 20px;\n    background: white;\n    padding: 10px;\n    border-radius: 5px;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.tags-table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 600px; /* حداقل عرض برای جلوگیری از فشردگی بیش از حد */\n}\n\n.tags-table th,\n.tags-table td {\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: center;\n}\n\n.tags-table th {\n    background: #007bff;\n    color: white;\n}\n\n.tags-table tbody tr:nth-child(even) {\n    background: #f2f2f2;\n}\n\n/* واکنش‌گرایی برای موبایل */\n@media screen and (max-width: 768px) {\n    .table-container {\n        overflow-x: auto; /* فعال کردن اسکرول افقی */\n        display: block;\n        white-space: nowrap; /* جلوگیری از شکستگی متن */\n    }\n\n    .tags-table {\n        font-size: 14px;\n        min-width: 500px;\n    }\n\n    .tags-table th,\n    .tags-table td {\n        padding: 8px;\n    }\n\n    .button-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .btn {\n        width: 90%;\n        margin: 5px 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
